import { AlertTriangle, Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEditor } from "@/components/editor/useEditorState";

export default function AiPreviewBanner() {
  const { aiPreview, setAiPreview } = useEditor();
  if (!aiPreview) return null;
  return (
    <div className="mx-2 md:mx-4 mt-2 flex flex-wrap items-center gap-2 rounded-lg border border-sky-300 bg-sky-50 px-3 py-2 text-xs text-sky-900 shadow-sm" data-testid="ai-preview-banner">
      <Eye size={14} className="shrink-0" />
      <span className="min-w-0 flex-1">Stai vedendo l'<b>anteprima della proposta AI</b> «{aiPreview.label}». Il progetto non è ancora cambiato.</span>
      {aiPreview.stale && <span className="inline-flex items-center gap-1 text-amber-700"><AlertTriangle size={12} />Elementi modificati dopo la proposta</span>}
      <Button size="sm" variant="outline" className="h-7 bg-white" onClick={() => setAiPreview(null)} data-testid="ai-preview-close-btn"><X size={12} className="mr-1" />Chiudi anteprima</Button>
    </div>
  );
}
